<div hlmPopover align="end">
  <button hlmPopoverTrigger class="relative p-1.5 rounded-md hover:bg-accent transition-colors cursor-pointer">
    <svg class="w-5 h-5 text-muted-foreground" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M10.268 21a2 2 0 0 0 3.464 0"/><path d="M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326"/>
    </svg>
    @if (hasUnread()) {
      <span class="absolute -top-0.5 -right-0.5 flex items-center justify-center min-w-[16px] h-4 px-1 rounded-full bg-destructive text-white text-[10px] font-medium leading-none">
        {{ unreadCount() > 99 ? '99+' : unreadCount() }}
      </span>
    }
  </button>

  <div *hlmPopoverPortal hlmPopoverContent class="w-80 p-0">
    <div class="flex items-center justify-between px-4 py-3 border-b border-border">
      <span class="text-sm font-medium">Notifications</span>
      @if (hasUnread()) {
        <button
          type="button"
          class="text-xs text-primary hover:underline"
          (click)="markAllRead()"
        >
          Mark all read
        </button>
      }
    </div>

    <div class="max-h-[360px] overflow-y-auto">
      @for (notification of notifications(); track notification.id) {
        <button
          type="button"
          class="group w-full text-left px-4 py-3 border-b border-border/50 last:border-0 hover:bg-muted/50 transition-colors cursor-pointer"
          [class.bg-muted/30]="!notification.isRead"
          [class.bg-emerald-50/40]="notification.type === 'Success'"
          [class.border-l-2]="notification.type === 'Warning' || notification.type === 'Success' || notification.type === 'Error'"
          [class.border-l-amber-500]="notification.type === 'Warning'"
          [class.border-l-emerald-500]="notification.type === 'Success'"
          [class.border-l-destructive]="notification.type === 'Error'"
          (click)="onNotificationClick(notification)"
        >
          <div class="flex items-start gap-2">
            <div class="mt-1 shrink-0 w-4 h-4 flex items-center justify-center">
              @if (notification.type === 'Success') {
                <svg class="w-4 h-4 text-emerald-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M20 6 9 17l-5-5"/>
                </svg>
              } @else if (notification.type === 'Warning') {
                <svg class="w-4 h-4 text-amber-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
                </svg>
              } @else if (notification.type === 'Error') {
                <svg class="w-4 h-4 text-destructive" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10"/><line x1="12" x2="12" y1="8" y2="12"/><line x1="12" x2="12.01" y1="16" y2="16"/>
                </svg>
              } @else if (!notification.isRead) {
                <span class="w-2 h-2 rounded-full bg-primary"></span>
              }
            </div>
            <div class="flex-1 min-w-0">
              <div class="flex items-start justify-between gap-1">
                <p class="text-sm font-medium truncate">{{ notification.title }}</p>
                <button
                  type="button"
                  class="shrink-0 p-0.5 rounded hover:bg-muted-foreground/20 opacity-0 group-hover:opacity-100 transition-opacity cursor-pointer"
                  (click)="deleteNotification($event, notification)"
                >
                  <svg class="w-3.5 h-3.5 text-muted-foreground" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M18 6 6 18"/><path d="m6 6 12 12"/>
                  </svg>
                </button>
              </div>
              <p class="text-xs text-muted-foreground line-clamp-2 mt-0.5">{{ notification.message }}</p>
              <div class="flex items-center justify-between mt-1">
                <p class="text-xs text-muted-foreground">{{ timeAgo(notification.createdDate) }}</p>
                @if (notification.relatedEntityId != null) {
                  <span class="text-xs text-primary">View</span>
                }
              </div>
            </div>
          </div>
        </button>
      } @empty {
        <p class="text-sm text-muted-foreground text-center py-8">No notifications</p>
      }
    </div>
  </div>
</div>
